module.exports = __webpack_public_path__ + "media/images/dallas_02_small-d4d74bcebbc1a9ee0eeee0612bc3ad64.jpg";